export const theme = {
  light: {
    logoSize: '240px',
    fontSrc:
      'https://fonts.googleapis.com/css2?family=Open+Sans:ital,wght@0,400;0,600;0,700;1,400&display=swap',
    bodyBackground: '#fff',
    baseFontFamily: 'Open sans, serif',
    baseFontSize: '14px',
    fontNormal: '400',
    fontSemiBold: '600',
    fontBold: '700',
    baseLineHeight: '1.6rem',
    headingFontFamily: 'Open sans, serif',
    headingFontSize: '14px',
    headingLineHeight: '1.6rem',
    primaryBgColor: '#040332',
    primaryTextColor: '#fff',
    primaryBgColorHover: '#1147bb',
    primaryTextColorHover: '#fff',
  },
  dark: {
    logoSize: '240px',
    fontSrc:
      'https://fonts.googleapis.com/css2?family=Cairo:wght@400;700&display=swap',
    bodyBackground: '#fff',
    baseFontFamily: "'Cairo', sans-serif",
    baseFontSize: '14px',
    fontNormal: '400',
    fontSemiBold: '700',
    fontBold: '700',
    baseLineHeight: '1.6rem',
    headingFontFamily: "'Cairo', sans-serif",
    headingFontSize: '14px',
    headingLineHeight: '1.6rem',
    primaryBgColor: '#040332',
    primaryTextColor: '#fff',
    primaryBgColorHover: '#1147bb',
    primaryTextColorHover: '#fff',
  },
};
